import {useMemo} from 'react';

import {Icon, IconName, IconProps} from 'components';
import {ParticipantRole} from 'types';

type Props = {
    role: ParticipantRole;
} & Partial<IconProps>;

export const ParticipantIcon: React.FC<Props> = ({role, ...iconProps}: Props) => {
    const iconName: IconName = useMemo(() => {
        if (role === ParticipantRole.Agent) {
            return 'agent-participant';
        } else if (role === ParticipantRole.Client) {
            return 'client-participant';
        } else if (role === ParticipantRole.Assistant) {
            return 'assistant-participant';
        } else if (role === ParticipantRole.Guest) {
            return 'guest-participant';
        }
        return null;
    }, [role]);

    return iconName ? <Icon {...iconProps} name={iconName} /> : null;
};